export const InformationTypes = {
  IInformationService: Symbol("IInformationService"),
};
